const jsonify = (almostJson) => {
  try {
    return JSON.parse(almostJson);
  } catch (e) {
    almostJson = almostJson.replace(/([a-zA-Z0-9_$]+\s*):/g, '"$1":').replace(/'([^']+?)'([\s,\]\}])/g, '"$1"$2');
    return JSON.parse(almostJson);
  }
};

const chars = {
  '[': ']',
  '{': '}'
};

const any = (iteree, iterator) => {
  let result;
  for (let i = 0; i < iteree.length; i++) {
    result = iterator(iteree[i], i, iteree);
    if (result) {
      break;
    }
  }
  return result;
};

const extract = (str) => {
  let startIndex = str.search(/[\{\[]/);
  if (startIndex === -1) {
    return [str, null];
  }
  if (startIndex > 0) {
    return [str.substr(0, startIndex), str.substr(startIndex)];
  }

  let openingChar = str[ startIndex ];
  let closingChar = chars[ openingChar ];
  let endIndex = -1;
  let depth = 0;

  any(str, (letter, i) => {
    if (letter === openingChar) {
      depth++;
    } else if (letter === closingChar) {
      depth--;
    }
    if (!depth) {
      endIndex = i;
      return true;
    }
  });

  if (endIndex === -1) {
    return [str, null];
  }

  let obj = str.substring(0, endIndex + 1);
  return [obj, str.substr(endIndex+1)];
};

// replace json in given string with parsed object
const parseInlineJSON = (str) => {
  const result = [];

  while (str !== null) {
    const [obj, remaining] = extract(str);
    try {
      result.push(jsonify(obj));
    } catch (e) {
      result.push(obj.trim())
    }
    str = remaining;
  }

  return result.filter(x => x !== '');
};

export default parseInlineJSON;
